/**
 * Tool unlock journey timing, edit here to speed up or slow down the experience.
 *
 * minDurationMs
 *   Minimum time the “unlocking” state runs before the success frame appears,
 *   even if the server responds instantly. Increase for a longer ritual; decrease for snappier UX.
 *
 * messageIntervalMs
 *   How often loading toasts rotate while unlocking.
 *
 * messages
 *   Toast copy shown in order (loops). Add lines to stretch the feel without changing timers.
 */
export const TOOL_UNLOCK_TIMING = {
  minDurationMs: 3200,
  messageIntervalMs: 2000,
  messages: [
    'Reserving your copy…',
    'Opening Google Drive…',
    'Pulling the sheet file…',
    'Preparing your copy link…',
    'Adding it to your library…',
    'Almost there…',
  ],
};
